import { render, staticRenderFns } from "./CreateCoursesMaterialsDialog.vue?vue&type=template&id=aae5e926&"
import script from "./CreateCoursesMaterialsDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateCoursesMaterialsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CreateCoursesMaterialsDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VBtn,VContent})
